import request from '@/request/request'

// 查询资源列表
export function listResourcePoi(query) {
    return request({
        url: '/api/equipment-server/resourcePoi/list',
        method: 'get',
        params: query
    })
}

// 查询资源详细
export function getResourcePoiById(id) {
    return request({
        url: '/api/equipment-server/resourcePoi/' + id,
        method: 'get'
    })
}

// 新增资源
export function addResourcePoi(data) {
    return request({
        url: '/api/equipment-server/resourcePoi',
        method: 'post',
        data: data
    })
}

// 修改资源
export function updateResourcePoi(data) {
    return request({
        url: '/api/equipment-server/resourcePoi/edit',
        method: 'post',
        data: data
    })
}

// 删除资源
export function delResourcePoi(id) {
    return request({
        url: '/api/equipment-server/resourcePoi/delete/' + id,
        method: 'post'
    })
}
